export const parcePointers = {
    slot: {
        spine: 'spine_',
        text: 'text_',
        button: 'button_',
    },
    folder: {
        state: 'state_',
        event: 'event_',
    },
    mod: {
        next: '_next',
        loop: '_loop',
    },
};
